export default __webpack_public_path__ + "static/media/EmptyNominations.bb78ffe2.svg";